import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { MapProvider } from 'contexts/MapContext';
import MapWithContext from './MapWithContext';

interface IMatchParams {
  id: string;
  signature: string;
}

const Map: React.FC<RouteComponentProps<IMatchParams>> = (props) => {
  return (
    <MapProvider>
      <MapWithContext {...props} />
    </MapProvider>
  );
};

export default Map;